import { Reservation } from '../models/reserve';

export interface ReservationService {
  getReservations(): Promise<Reservation[]>;
  getReservation(id: number): Promise<Reservation>;
  updateReservation(reservation: Reservation): Promise<Reservation>;
  deleteReservation(id: number): Promise<void>;
}

class ReservationServiceImpl implements ReservationService {
  private baseURL = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api/v1`;

  async getReservations(): Promise<Reservation[]> {
    const response = await fetch(`${this.baseURL}/reserve/all`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`予約一覧の取得に失敗しました: ${response.status}`);
    }

    return response.json();
  }

  async getReservation(id: number): Promise<Reservation> {
    const response = await fetch(`${this.baseURL}/reserve/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`予約の取得に失敗しました: ${response.status}`);
    }

    return response.json();
  }

  async updateReservation(reservation: Reservation): Promise<Reservation> {
    // 更新用データを作成（バックエンドのUpdateReserve DTOに合わせる）
    const updateData: any = {};

    // 必要なフィールドのみを含める（undefined/nullでないものだけ）
    if (reservation.name !== undefined) updateData.name = reservation.name;
    if (reservation.email !== undefined) updateData.email = reservation.email;
    if (reservation.menu !== undefined) updateData.menu = reservation.menu;
    if (reservation.time !== undefined) updateData.time = reservation.time;
    if (reservation.date !== undefined) updateData.date = reservation.date;
    if (reservation.amount !== undefined)
      updateData.amount = reservation.amount;
    if (reservation.menuDetails !== undefined)
      updateData.menuDetails = reservation.menuDetails;
    if (reservation.totalPrice !== undefined)
      updateData.totalPrice = reservation.totalPrice;

    const response = await fetch(
      `${this.baseURL}/reserve/${reservation.id}/update`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(updateData),
      }
    );

    if (!response.ok) {
      throw new Error(`予約の更新に失敗しました: ${response.status}`);
    }

    return response.json();
  }

  async deleteReservation(
    id: number,
    deleteByAdmin: boolean = false
  ): Promise<void> {
    const response = await fetch(
      `${this.baseURL}/reserve/${id}/delete?deleteByAdmin=${deleteByAdmin}`,
      {
        method: 'DELETE',
        credentials: 'include',
      }
    );

    if (!response.ok) {
      throw new Error(`予約の削除に失敗しました: ${response.status}`);
    }
  }
}

const reservationService = new ReservationServiceImpl();
export default reservationService;
